import {stringToDateConvertor} from "./stringToDateConvertor";


export const removeTestCourse = (list) => {
    return list.filter((course) => course.id !== 1)
}
export const defineBookedCoursesSelector = (list, userBookings, isDev) => {
    const golfCoursesList = isDev ? list : removeTestCourse(list);

    if (golfCoursesList.length > 0 && userBookings.length > 0) {

        // find indexes courses from user bookings
        userBookings.forEach((booking) => {
            const courseId = booking.data.course.id;
            const date = stringToDateConvertor(booking.data.date);
            const courseIndex = golfCoursesList.findIndex((course) => course.id === courseId);
            const isBooked = courseIndex !== -1;
            if(isBooked){
                const isToday = date.toDateString() === new Date().toDateString();
                if (isToday) {
                    golfCoursesList[courseIndex].data.isTodayBooked = true
                }else{
                    golfCoursesList[courseIndex].data.isBooked = true
                }
            }

        })
        return golfCoursesList;
    }
    return list;
}
